import { ItemsPerPage } from '@billy/design-system'
import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { AttachmentFillType } from '@features/attachments/enums/attachmentFillType'
import { AttachmentFilterType } from '@features/attachments/enums/attachmentFiltertype'
import { useGetFetchAttachmentsQueryProps } from '@features/attachments/hooks/useGetFetchAttachmentsQueryProps'
import { getAttachmentsApiFilter } from '@features/attachments/utils/getAttachmentsApiFilter'
import { getAttachmentsQueryKey } from '@features/attachments/utils/getAttachmentsQueryKey'
import { useIsEInvoicingOnly } from '@features/bills/hooks/useIsEInvoicingOnly'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getReceiptsQueryFunction } from '../utils/getReceiptsQueryFunction'
import { useAttachmentsFilters } from './useAttachmentsFilters'

interface UseGetFirstReceiptProps {
  type?: AttachmentFilterType
}

export const useGetFirstReceipt = ({ type = AttachmentFilterType.All }: UseGetFirstReceiptProps) => {
  const { organization } = useUserOrganization()
  const [{ sortBy, sortDirection }] = useAttachmentsFilters()
  const isEInvoicingOnly = useIsEInvoicingOnly()

  const { type: apiType, eInvoiceFilter } = getAttachmentsApiFilter(type, false, isEInvoicingOnly)

  const queryProps = useGetFetchAttachmentsQueryProps({
    page: 1,
    pageSize: 1 as ItemsPerPage,
    sortDirection,
    searchQuery: '',
    sortBy,
    type: apiType,
    eInvoiceFilter,
    fillType: AttachmentFillType.Nonfilled,
  })

  const queryKey = getAttachmentsQueryKey(queryProps)

  const { data } = useQuery(queryKey, () => getReceiptsQueryFunction(queryProps), {
    enabled: !!organization,
  })

  return useMemo(
    () => ({
      attachment: data?.attachments[0],
    }),
    [data],
  )
}
